import SoftBox from "src/components/SoftBox";
import IconButton from "@mui/material/IconButton";
import { Icon } from "@mui/material";
import SoftTypography from "src/components/SoftTypography";

const iconButtonStyles = ({ typography: { size }, breakpoints }: any) => ({
  px: 0.9,

  "& .material-icons, .material-icons-round": {
    fontSize: `${size.md} !important`,
  },

  "& .MuiTypography-root": {
    display: "none",

    [breakpoints.up("sm")]: {
      display: "inline-block",
      lineHeight: 1.2,
      ml: 0.5,
    },
  },
});

export const TableActions = {
  EDIT: "EDIT",
  DELETE: "DELETE",
  TOGGLE: "TOGGLE",
};

export const getTableColumns = (onAction: any) => [
  {
    Header: "Label",
    accessor: "label",
    Cell: ({ row: { original } }: any) => (
      <SoftBox sx={{ display: "flex" }}>
        <SoftBox
          sx={{
            width: "10px",
            height: "26px",
            borderRadius: "3px",
            backgroundColor: original?.color,
            marginRight: "10px",
          }}
        />
        <SoftTypography variant="body2">{original.label}</SoftTypography>
      </SoftBox>
    ),
  },
  {
    Header: "Actions",
    width: "13%",
    Cell: ({ row: { original } }: any) => (
      <SoftBox sx={{ display: "flex" }}>
        {original?.hideDelete ? (
          <SoftBox mx={0.9} width="16px" height="16px" />
        ) : (
          <IconButton
            aria-label="delete"
            sx={iconButtonStyles}
            onClick={() => onAction(TableActions.DELETE, original)}
          >
            <Icon>delete</Icon>
          </IconButton>
        )}
        <IconButton
          aria-label="edit"
          sx={iconButtonStyles}
          onClick={() => onAction(TableActions.EDIT, original)}
        >
          <Icon>edit</Icon>
        </IconButton>
      </SoftBox>
    ),
  },
];
